import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconChevronDown = createIcon({
  displayName: 'IconChevronDown',
  path: [
    <path
      key="0"
      d="M12 18.41L2.28998 8.71L3.70998 7.29L12 15.59L20.29 7.29L21.71 8.71L12 18.41Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
